export enum WorkTypes {
  All = 0,
  VIK = 1,
  EGov = 2
}
